import React, { useEffect } from 'react'
import { AiFillEye } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import PageTitle from '../../../components/partials/PageTitle'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import { getPendingClaims } from '../../../redux/slice/pendingActions/pendingActionsSlice'
import { useDispatch } from 'react-redux'
import { resetSingleClaims } from '../../../redux/slice/claim/savingClaimSlice'

const PendingActions = () => {

    const { user_role: user_role_array, user } = useSelector((state) => state?.auth?.user)
    const { pending_claims_processes, pending_savings_claim } = useSelector(
        (state) => state?.pendingActions
    );
    const dispatch = useDispatch();


    const breadcrumb = {
        'from': {
            'title': 'Dashboard',
            'link': '/admin/dashboard'
        },
        'current': {
            'title': 'Workflow',
            'link': null
        }
    }

    useEffect(() => {
        dispatch(getPendingClaims({user_role_array, office_id: user?.office_id}))
        dispatch(resetSingleClaims())
      }, [dispatch, user?.office_id, user_role_array])
    
  return (
    <>
        {/* page title */}
        <PageTitle title='Workflow' breadcrumb={breadcrumb}/>
        {/* end page title */}
        <div className="row">
            <div className="col-md-12">
                <div className="card p-2">
                   <div>
                        <a className="d-flex justify-content-between form-control shadow border-0" data-bs-toggle="collapse" href="#multiCollapseExample1" role="button" aria-expanded="false" aria-controls="multiCollapseExample1">
                            <span>Claims Pending Actions</span>
                            <span >
                                <MdOutlineKeyboardArrowDown />
                            </span>
                        </a>
                   </div>
                   <div class="row mt-1">
                        <div class="col">
                            <div class="collapse multi-collapse" id="multiCollapseExample1">
                                <div class="card card-body">
                                    {pending_claims_processes?.length < 1 ? 
                                    <h5 className='alert alert-info'>You have no pending actions</h5> :
                                    <div>
                                        {pending_claims_processes?.map((item, index) => (
                                            <div
                                                key={index}
                                                className='d-flex justify-content-between align-items-center form-control shadow border-0 mb-2'
                                            >
                                                <span>{item.claim_id}</span>
                                                <Link
                                                    className='text-primary cursor-p'
                                                    to={`/admin/claims/edit`}
                                                    state={{ id: item?.claim_id }}
                                                >
                                                    <span>
                                                    <AiFillEye size={20} />
                                                    </span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="card p-2">
                   <div>
                        <a className="d-flex justify-content-between form-control shadow border-0" data-bs-toggle="collapse" href="#multiCollapseExample2" role="button" aria-expanded="false" aria-controls="multiCollapseExample2">
                            <span>Savings Claims Pending Actions</span>
                            <span >
                                <MdOutlineKeyboardArrowDown />
                            </span>
                        </a>
                   </div>
                   <div class="row mt-1">
                        <div class="col">
                            <div class="collapse multi-collapse" id="multiCollapseExample2">
                                <div class="card card-body">
                                    {pending_savings_claim?.length < 1 ? 
                                    <h5 className='alert alert-info'>You have no pending actions</h5> :
                                    <div>
                                        {pending_savings_claim?.map((item, index) => (
                                            <div
                                                key={index}
                                                className='d-flex justify-content-between align-items-center form-control shadow border-0 mb-2'
                                            >
                                                <span>{item.claim_id}</span>
                                                <Link
                                                    className='text-primary cursor-p'
                                                    to={`/admin/claims/all-savings-claims/edit`}
                                                    state={{ claim_type:item?.claim_type, claim_category: item?.claim_category, claim_id: item?.claim_id, policy_application_number: item?.policy_app_no, customer_id: item?.customer_id}}
                                                >
                                                    <span>
                                                    <AiFillEye size={20} />
                                                    </span>
                                                </Link>
                                            </div>
                                        ))}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
  )
}

export default PendingActions